/**
 * TanStack Query mutation for adding a reviewer comment to a KYC form via tRPC.
 */

import { useQueryClient } from "@tanstack/react-query";
import { transformDBKYBToKYCFormData } from "../services/data/api/kycProvider";
import { trpc } from "../trpc";

export function useKYBAddComment() {
	const queryClient = useQueryClient();
	const utils = trpc.useUtils();

	const mutation = trpc.kyb.addComment.useMutation({
		onSuccess: (result, variables) => {
			const updated = transformDBKYBToKYCFormData(result);
			queryClient.setQueryData(["kyb", variables.id], updated);
			utils.kyb.list.invalidate();
		},
	});

	return {
		...mutation,
		mutate: ({
			formId,
			author,
			text,
			isInternal,
		}: {
			formId: string;
			author: string;
			text: string;
			isInternal: boolean;
		}) => {
			mutation.mutate({
				id: formId,
				author,
				text,
				is_internal: isInternal,
			});
		},
		mutateAsync: async ({
			formId,
			author,
			text,
			isInternal,
		}: {
			formId: string;
			author: string;
			text: string;
			isInternal: boolean;
		}) => {
			const result = await mutation.mutateAsync({
				id: formId,
				author,
				text,
				is_internal: isInternal,
			});
			return {
				formId,
				updated: transformDBKYBToKYCFormData(result),
			};
		},
	};
}
